import React from "react";
import { SvgComponent } from "@commons/Componentes/SvgComponent/SvgComponent";

// El titulo lo pone la primera pregunta; mientras no haya ninguna, el chat esta vacio.
const tituloDe = (conversacion) => conversacion?.Titulo || "Nueva conversación";

const formatearFecha = (valor) => {
  if (!valor) return "";

  // Las fechas de ASP.NET llegan como /Date(1234567890)/ o como ISO, según el serializador.
  const milisegundos = /\/Date\((-?\d+)/.exec(String(valor));
  const fecha = milisegundos ? new Date(Number(milisegundos[1])) : new Date(valor);
  if (Number.isNaN(fecha.getTime())) return "";

  return fecha.toLocaleDateString("es-DO", { day: "2-digit", month: "short", year: "numeric" });
};

/** El historial de conversaciones, de cinco en cinco, de la más reciente a la más vieja. */
export const ChatRecientes = ({
  conversaciones,
  actualId,
  onAbrir,
  ocupado,
  hayMas,
  onVerMas,
  cargando
}) => (
  <div className="citrus-gpt-aside">
    <div className="citrus-gpt-aside__header">
      <span className="citrus-gpt-icon" style={{ width: 32, height: 32, borderRadius: 10 }}>
        <SvgComponent iconName="history" width="17px" height="17px" fill="currentColor" />
      </span>
      <h3>Chats recientes</h3>
    </div>

    {conversaciones?.length ? (
      <>
        <ul className="citrus-gpt-aside__list">
          {conversaciones.map((conversacion) => (
            <li key={conversacion.Id}>
              <button
                type="button"
                disabled={ocupado}
                onClick={() => onAbrir(conversacion.Id)}
                className={`citrus-gpt-aside__item${
                  conversacion.Id === actualId ? " citrus-gpt-aside__item--activo" : ""
                }`}
              >
                <span className="citrus-gpt-aside__titulo" title={tituloDe(conversacion)}>
                  {tituloDe(conversacion)}
                </span>
                <span className="citrus-gpt-aside__fecha">
                  {formatearFecha(conversacion.FechaCreacion)}
                  {conversacion.EsActiva ? " · abierta" : ""}
                </span>
              </button>
            </li>
          ))}
        </ul>

        {hayMas && (
          <button
            type="button"
            className="citrus-gpt-aside__mas"
            onClick={onVerMas}
            disabled={cargando || ocupado}
          >
            {cargando ? "Cargando..." : "Ver más"}
          </button>
        )}
      </>
    ) : (
      <p className="citrus-gpt-aside__empty">
        Todavía no hay conversaciones. La primera pregunta abre una.
      </p>
    )}
  </div>
);
